export default "__VITE_ASSET__eWX4Hr8g__"